import React from 'react';
import { View } from 'react-native';
import { cn } from '@/utils/cn';

type StaticListProps<T> = {
  data: readonly T[];
  keyExtractor: (item: T, index: number) => string;
  renderItem: (item: T, index: number) => React.ReactNode;
  className?: string;
};

/** Lista estática para uso dentro de ScrollView (evita FlatList aninhada). */
export function StaticList<T>({ data, keyExtractor, renderItem, className }: StaticListProps<T>) {
  return (
    <View className={cn('gap-3', className)}>
      {data.map((item, index) => (
        <React.Fragment key={keyExtractor(item, index)}>{renderItem(item, index)}</React.Fragment>
      ))}
    </View>
  );
}
